import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-kaggle',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Kaggle icon</title><path d="M18.825 23.859c-.022.092-.117.141-.281.141h-3.139c-.187 0-.351-.082-.492-.248l-5.178-6.589-1.448 1.374v5.111c0 .235-.117.352-.351.352H5.505c-.236 0-.354-.117-.354-.352V.353c0-.233.118-.353.354-.353h2.431c.234 0 .351.12.351.353v14.343l6.203-6.272c.165-.165.33-.246.495-.246h3.239c.144 0 .236.06.285.18.046.149.034.255-.036.315l-6.555 6.344 6.836 8.507c.095.104.117.208.07.358"/></svg>`,
    styles: []
})
export class SimpleIconsKaggleComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#20BEFF';
    @Input() className: string = 'simple-icons-kaggle'
    constructor() {}
    ngOnInit(): void {}
}
